export enum RoleGroup {
    TRAVELLER = 'TRAVELLER',
    TRAVEL_ADMIN = 'TRAVEL_ADMIN',
    MANAGER = 'MANAGER',
    HR = 'HR',
    FINANCE = 'FINANCE',
    COMPANY_ADMIN = 'COMPANY_ADMIN',
    VENDOR_ADMIN = 'VENDOR_ADMIN',
    VENDOR_AGENT = 'VENDOR_AGENT',
    VENDOR_FINANCE = 'VENDOR_FINANCE',
    CATALYCA_ADMIN = 'CATALYCA_ADMIN',
    CATALYCA_AGENT = 'CATALYCA_AGENT',
    PLATFORM_ADMIN = 'PLATFORM_ADMIN',
    CATALYCA_SALES = 'CATALYCA_SALES',

}

export const roleGroupDescription = (role: RoleGroup): string => {
    switch (role) {
        case RoleGroup.CATALYCA_ADMIN: return 'Catalyca Admin';
        case RoleGroup.COMPANY_ADMIN: return 'Company Admin';
        case RoleGroup.TRAVEL_ADMIN: return 'Travel Admin';
        case RoleGroup.TRAVELLER: return 'Travel Admin';
        case RoleGroup.FINANCE: return 'Travel Admin';
        case RoleGroup.PLATFORM_ADMIN: return 'Platform Admin';
        case RoleGroup.CATALYCA_SALES: return 'Catalyca Sales';
        case RoleGroup.CATALYCA_AGENT: return 'Catalyca Agent';
        case RoleGroup.VENDOR_AGENT: return 'Vendor Agent';

        default: return "User";
    }
}